import React, { useState } from "react";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { Link } from "react-router-dom";
import contactAPI from "../../api/contactApi";
import { showSuccess, showError } from "../../utils/toastUtils";
import useAlphabetsInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";
import Breadcrump from "../../components/Breadcrump";
import { motion } from "framer-motion";
import { MapPin, Mail, Phone, ArrowRight, X } from "lucide-react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import SocialLinks from "../../components/SocialLinks";

function ContactUs() {
  useAlphabetsInput();
  useNumericInput();
  const { config } = useSiteConfig();

  const INITAL_FORM_DATA = {
    email: "",
    phone: "",
    name: "",
    message: "",
  };

  const [formData, setFormData] = useState(INITAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please enter email address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone) {
      newErrors.phone = "Please enter phone";
    }

    if (!formData.name) {
      newErrors.name = "Please enter name";
    }

    if (!formData.message) {
      newErrors.message = "Please enter message";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await contactAPI.store(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <Breadcrump title="Contact Us" />
     <div className="botanical-grid-wrapper">
        <motion.div
          className="botanical-grid"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* --- LEFT COLUMN (Context & Info) --- */}
          <div className="left-col">
            <div className="grid-cell">
               <h1 className="display-title mb-4">
                Contact Us             
              </h1>
              <div className="info-row">
                <div className="info-icon">
                  <MapPin size={20} />
                </div>

                <div className="info-text">
                  <strong>Address</strong>
                  <span>
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon">
                  <Mail size={20} />

                </div>
                <div className="info-text">
                  <strong>General Inquiries</strong>
                  <span> <a className="text-muted" href={`mailto: ${config?.email}`}>
                    {config?.email}
                  </a></span>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon">
                  <Phone size={20} />
                </div>
                <div className="info-text">
                  <strong>Mobile Number</strong>
                  <span><a className="text-muted text-decoration-none" href={`tel:+91 ${config?.phone}`}>
                    +91 {config?.phone}
                  </a></span>
                </div>
              </div>
              <div className="social-icons">
                <SocialLinks socialMedia={config?.socialMedia} />
              </div>
            </div>

            {/* 2. Visual Cell */}
            <div className="image-cell">
              <img src={`${process.env.PUBLIC_URL}images/breadcrumb.png`} alt="Skin Lab" className="grid-img" />
            </div>



          </div>

          {/* --- RIGHT COLUMN (The Form) --- */}
          <div className="right-col">
            <div className="grid-cell h-100 border-0">

              <h2 className="font-serif mb-4">How can we help?</h2>

              <form method="post"
                onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="lab-input-group">
                      <label className="lab-label">First Name  <span className="text-danger">*</span></label>
                      <input type="text" className="lab-input" placeholder="Jane"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}

                      />
                      {errors.name && (
                        <span className="text-danger">{errors.name}</span>
                      )}
                    </div>

                  </div>

                </div>

                <div className="lab-input-group">
                  <label className="lab-label">Email Address  <span className="text-danger">*</span></label>
                  <input type="email" className="lab-input" placeholder="jane@example.com"

                    name="email"
                    value={formData.email}
                    onChange={handleChange}

                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email}</span>
                  )}


                </div>
                <div className="lab-input-group">
                  <label className="lab-label">Mobile Number  <span className="text-danger">*</span></label>
                  <input className="lab-input radius-8 only-numeric" placeholder=""

                    type="text"
                    maxLength={10}
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}

                  />
                  {errors.email && (
                    <span className="text-danger">{errors.phone}</span>
                  )}

                </div>

                <div className="lab-input-group">
                  <label className="lab-label">Your Message</label>
                  <textarea
                    className="lab-input"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}

                  />
                  {errors.message && (
                    <span className="text-danger">{errors.message}</span>
                  )}
                </div>

                <button className="btn-lab">
                  Submit <ArrowRight size={16} className="ms-2" />
                </button>
              </form>
            </div>
          </div>

        </motion.div >
      </div >

    </>
  );
}

export default ContactUs;